<template>
  <div id="contendor-principal-Pagos" style="position:relative;">
    <div id="contenedor-encabezados-Pagos" class="text-left">
        <h1>Pagos</h1>
        <h3 v-if="!rutaInhabilitar && !rutaDevolver">Búsqueda de Pagos</h3>
        <h3 v-if="rutaInhabilitar">Inhabilitar Pagos</h3> 
        <h3 v-if="rutaDevolver">Devolver Pagos</h3>    
    </div> 
    <div id="contendor-principal-Pagos" class="row mt-3">
      <!-- Filtro de Búsqueda -->
      <transition name="fade">
      <div  id="contenedor-filtros-Pagos" class="col-12 col-sm-12 col-md-12 col-lg-4 col-xlg-4">      
        <div > 
          <div v-if="((foliosSinImprimir != null && foliosSinImprimir.length > 0) || ultimoFolioNoImpreso != null)
                    && (!rutaInhabilitar && !rutaDevolver)">
            <PendientesImprimir
            :ultimoFolioNoImpreso="ultimoFolioNoImpreso"
            :foliosSinImprimir="foliosSinImprimir"
            :key="'pendientes'+contRenderPendientes">
            
            </PendientesImprimir>
          </div>
          <div class="area_verde">

            <FiltrosDeBusqueda 
                :catalogos="catalogos" 
                :elementosAOmitir ="elementosAOmitir"
                :AccionesMostrar="accionesMostrar"
                :AccionesPago="accionespago"
                :ejecutalimpiarTablaResultados="limpiarTablaResultados" 
                :ejecutaLaFuncion="buscarImputadoAPI"
                :tituloDeBusqueda="'Búsqueda del pago'"              
                :ref="'filtroBusqueda'"
                :key="'KfiltroBusqueda-' + contRenderBusqueda">
            </FiltrosDeBusqueda>
          </div>
        </div>             
      </div>
      </transition>
      <!-- Tabla de resultados  -->
      <div  class="'col-12 col-sm-12 col-md-12 col-lg-8 col-xlg-8  pt-sm-4 pt-md-4 pt-lg-0 pt-xlg-0" id="PagosEncontrados_div">
        <div class="area_verde">
          <transition name="fade">
          <div v-if="(Pagos == undefined || Pagos == null || Pagos.length <= 0) && (!accioneseditarpago.agregar && !accioneseditarpago.editar && !accionesdevolverpago.devolver && !accionesdevolverpago.editar)" style="background-color:var(--gris-pj); padding: 8px;">
            <div class="d-flex justify-content-center">
              <i class="fas fa-user-alt mr-sm-2" style="font-size: 25px;"></i>
              <div class="align-content-center">
                <h5 >Pagos encontrados</h5>
              </div>
            </div>
          </div>
          <TablaDeResultados 
            v-else-if="Pagos != undefined && Pagos != null"
            @valorParaElPadreAccion="accionRealizar"
            @editarPago="editarPago"
            @imprimirRecibo="imprimirRecibo"
            @inhabilitarPago="inhabilitarPago"
            @devolverPago="cargarPagoDevolver"
            @imprimirDevolucion="imprimirDevolucion"
            @eliminarDevolucion="eliminarDevolucion"
            @editarDevolucion="editarDevolucion"
            @cambiarEstatusDevolucion="cambiarEstatusDevolucion"
            @agregarRubro="agregarRubro"
            :AccionesMostrar="accionesMostrar"
            :Pagos="Pagos"
            :Inhabilitar="rutaInhabilitar"
            :Devolver="rutaDevolver"
            :ultimoFolio="(ultimoFolioNoImpreso) ? ultimoFolioNoImpreso : 0"
            :key="'TablaPagos' + contRenderTablaBusqueda">
          </TablaDeResultados>
          </transition>
          <transition><!--Componente que se agrego para la edicion</q>-->
              <FiltrosDeBusqueda
                v-if="(Pagos == null || Pagos == undefined) && accioneseditarpago.editar"
                @esAlPortador="esPortador"
                :AccionesPago="accioneseditarpago"
                :AccionesMostrar="accionesEditar"
                :catalogos="catalogos"
                :tituloDeBusqueda="'Editar Pago'"
                :elementosAConservar="obtenerAreaDeUsuario"  
                :ref="'filtroEditar'"
                :rubro="TipoRubroId"
                :doc="TipoDocumentoID"
                :ejecutaLaFuncion="guardarCambiosPago"
                :folio="folio"
                :materia="materiaID"
                :partidoJudicial="partidoJudicial"
                :pagoID="IDEditar"
                :AreaId="areaId"
                :cancelar="cancelar"
                :quitarRubros="quitarRubros"
                :key="'KfiltroEditar-' + contRenderEditar">
              </FiltrosDeBusqueda>
          </transition>
          <transition><!--Componente que se agrego para agregar rubro-->
              <FiltrosDeBusqueda
                v-if="(Pagos == null || Pagos == undefined) && accioneseditarpago.agregar"
                @esAlPortador="esPortador"
                :AccionesPago="accioneseditarpago"
                :AccionesMostrar="accionesEditar"
                :catalogos="catalogos"
                :tituloDeBusqueda="'Agregar Rubro a Folio: ' + folio"
                :elementosAConservar="obtenerAreaDeUsuario"  
                :ref="'filtroAgregar'"
                :rubro="TipoRubroId"
                :doc="TipoDocumentoID"
                :ejecutaLaFuncion="agregarNuevoRubro"
                :folio="folio"
                :materia="materiaID"
                :partidoJudicial="partidoJudicial"
                :pagoID="IDAgregar"
                :AreaId="areaId"
                :cancelar="cancelar"
                :quitarRubros="quitarRubros"
                :key="'KfiltroAgregar-' + contRenderAgregar">
              </FiltrosDeBusqueda>
          </transition>
          <transition><!--Componente que se agrego para la devolucion-->
              <FiltrosDeBusqueda
                v-if="(Pagos == null || Pagos == undefined) && accionesdevolverpago.devolver && DevolverPago && (CargarDevolucion != null)"
                :AccionesPago="accionesdevolverpago"
                :AccionesMostrar="accionesDevolver"
                :catalogos="catalogos"
                :tituloDeBusqueda="'Devolver Pago'"
                :elementosAConservar="obtenerAreaDeUsuario"  
                :ref="'filtroDevolver'"
                :folio="folio"
                :rubro="TipoRubroId"
                :doc="TipoDocumentoID"
                :materia="materiaID"
                :partidoJudicial="partidoJudicial"
                :AreaId="areaId"
                :ejecutaLaFuncion="devolverPago"
                :cancelar="buscarImputadoAPI"
                :totalDevuelto="totalDevuelto"
                :totalPagar="TotalMonto"
                :puestoremitenteId="puestoremitenteId"
                :tituloremitenteId="tituloremitenteId"
                :puestodestinatarioId="puestodestinatarioId"
                :titulodestinatarioId="titulodestinatarioId"
                :key="'KfiltroDevolucion' + contRenderDevolucion">
              </FiltrosDeBusqueda><!--cancelar ver si se deja asi o el normal-->
          </transition>    
          <transition><!--Componente que se agrego para la edicion de devolucion-->
              <FiltrosDeBusqueda
                v-if="(Pagos == null || Pagos == undefined) && accionesdevolverpago.editar && EditarDevolucion"
                :AccionesPago="accionesdevolverpago"
                :AccionesMostrar="accionesDevolver"
                :catalogos="catalogos"
                :tituloDeBusqueda="'Editar Devolucion'"
                :elementosAConservar="obtenerAreaDeUsuario"  
                :ref="'filtroEditarDevolucion'"
                :folio="folio"
                :rubro="TipoRubroId"
                :doc="TipoDocumentoID"
                :materia="materiaID"
                :partidoJudicial="partidoJudicial"
                :AreaId="areaId"
                :banco="bancoId"
                :ejecutaLaFuncion="guardarCambiosDevolucion"
                :cancelar="buscarImputadoAPI"
                :totalDevuelto="totalDevuelto"
                :totalPagar="TotalMonto"
                :puestoremitenteId="puestoremitenteId"
                :tituloremitenteId="tituloremitenteId"
                :puestodestinatarioId="puestodestinatarioId"
                :titulodestinatarioId="titulodestinatarioId"
                :key="'KfiltroEdicionDevolucion' + contRenderEdicionDevolucion">
              </FiltrosDeBusqueda><!--cancelar ver si se deja asi o el normal-->
          </transition>
          <transition>
            <EstatusDevolucion
            v-if="accionesDevolver.cambiarestatus"
            :AccionesMostrar="accionesDevolver"
            :AccionesPago="accionesdevolverpago"
            :elementosAConservar="obtenerAreaDeUsuario" 
            :ejecutaLaFuncion="actualizarEstatusDevolucion"
            :quitarMenu="quitarMenuEstatus"
            :ref="'cambioEstatus'">
                
            </EstatusDevolucion>
          </transition>        
        </div>  
      </div>
      <div id="Recibo" style="display: none;">
          <Recibo
            :folio="folio"
            :Pagos="Pagos"
            :ref="'datosRecibo'">
          </Recibo>
      </div>
      <div id="ReciboDevolucion" style="display: none;">
          <ReciboDevolucion
            :folio="folio"
            :Pago="DevolverPago"
            :ref="'datosReciboDevolucion'">
          </ReciboDevolucion>
      </div> 
    </div>
    
  </div>
</template>



<script>
import Vue from 'vue'
import TablaDeResultados from '@/components/SIVAC/Comun/TablaDeResultados.vue'
import FiltrosDeBusqueda from '@/components/SIVAC/Comun/FiltrosDeBusqueda.vue'
import Recibo from '@/components/SIVAC/Caja/Recibo.vue'
import ReciboDevolucion from '@/components/SIVAC/Caja/ReciboDevolucion.vue'
import PendientesImprimir from '@/components/SIVAC/Caja/PendientesImprimir.vue'
import enumeraciones from '@/../static/js/enumeraciones'
import comun from "@/../static/js/comun"
import func from '../Comun/Funciones/comun.js'
import api from '@/../static/js/api'
import axios from 'axios'
import EstatusDevolucion from '@/components/SIVAC/Caja/CambiarEstatusDevolucion.vue'
import { servicioRestPost } from '../../Audiencias/Programacion/servicios/ServiciosHttp.js'

export default {
    computed:{
//@agregarRubro="agregarRubro" va en tabladeresultados
      obtenerAreaDeUsuario : function()
      {
        if(this.$route.name === 'Pagos'){
            this.getFoliosSinImprimir()
        }
        let ep = {  
           tiposDocumento: [1, 23, 26],
           areas: [95, 54, 53, 48, 52, 51, 12],
           //partidosJudiciales: [1],
           materias: [6, 9],
           puestosremitente: [219, 498],
           puestosdestinatario: [195,11],
           estatusdevolucion: [2, 3]
        }
        return ep;
      },
      total(){
        if(this.DevolverPago){
            return this.DevolverPago.Devoluciones.reduce((sum, Pagos)=>{
              return (Pagos.Devuelto) ? sum + Pagos.MontoRecibo : sum
            }, 0)
        }
      },


    },
    components: {
      FiltrosDeBusqueda,
      TablaDeResultados,
      Recibo,
      ReciboDevolucion,
      EstatusDevolucion,
      PendientesImprimir,

    },
    data(){
      return{
        enumeraciones,
        servicioRestPost,
        contRenderEditar: 0,
        contRenderDevolucion: 0,
        contRenderBusqueda: 0,
        contRenderEdicionDevolucion: 0,
        contRenderTablaBusqueda: 0,
        contRenderPendientes: 0,
        contRenderAgregar: 0,
        accionesMostrar:{            
          firma: false,
          pagos: true,
          guardar: false,
          buscar: true,
          editar: false   
        },
        accionesEditar:{
          firma: false,
          pagos: true,
          guardar: true,
          buscar: false, 
          editar: true, 
          devolver: false   
        },
        accionesDevolver:{
          firma: false,
          pagos: true,
          guardar: true,
          buscar: false, 
          devolver: true,
          cambiarestatus: false  
        },
        accionespago:{
          busqueda: true,
          alta: false,
          editar: false,
          devolver: false
        },
        accioneseditarpago:{
          busqueda: false,
          alta: false,
          editar: false,
          devolver: false,
          agregar: false,
        },
        accionesdevolverpago:{
          busqueda: false,
          alta: false,
          editar: false,
          devolver: false,
        },
        catalogos: [          
          { catalogoId: enumeraciones.catalogos.PartidosJudiciales, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_PartidoJudicial' },
          { catalogoId: enumeraciones.catalogos.Juzgados, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_Area' },
          { catalogoId: enumeraciones.catalogos.Materias, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_Materia' },
          { catalogoId: enumeraciones.catalogos.TiposDeDocumentos, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_TipoDocumento' },
          { catalogoId: enumeraciones.catalogos.Consecutivo, idDelInput: 'filtroDeBusqueda_Consecutivo_Firmas' },          
          { catalogoId: enumeraciones.catalogos.NumeroExtra, idDelInput: 'filtroDeBusqueda_NoExtra_Firmas' },
          
          { catalogoId: enumeraciones.catalogos.Rubros, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_Rubro' },
          { catalogoId: enumeraciones.catalogos.Bancos, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_Banco' },
          { catalogoId: enumeraciones.catalogos.Puestos, etiquetaDeHtml: enumeraciones.etiquetasDeHTML.Select, tipoDeSelect: enumeraciones.tiposDeSelect.Seleccione, idDelInput: 'filtroDeBusqueda_Puestos' },
        ],
        elementosAOmitir: {
          //materias: [5,10] //áreas de Majat
        },
        Pagos: null,
        folio: null,
        EditarPago: null,///////campos agregados para enviar a filtrosdebusqueda.vue y podeer editar
        DevolverPago: null, //////devolver
        DevolverNombre: null,
        CargarDevolucion: null,
        EditarDevolucion: null,
        EditarDevolucionPago: null,
        rubroId: 0,
        expedienteId: 0,
        TipoRubroId: 0,
        TipoDocumentoID: 0,
        materiaID: 0,
        partidoJudicial: 0,
        areaId: 0,
        esAlPortador: false,
        IDEditar : Array,
        IDAgregar : Array,
        accionRealizar : Function,
        impreso: false,
        rutaInhabilitar: false,
        rutaDevolver: false,
        PagosAImprimir : null,
        TotalMonto: 0,
        bancoId: 0,
        puestoremitenteId: 0,
        tituloremitenteId: 0,
        puestodestinatarioId: 0,
        titulodestinatarioId: 0,
        areadestinatarioId: 0,
        devolucionId: 0,
        totalDevuelto: 0,
        Pago: null,
        foliosSinImprimir: null,
        ultimoFolioNoImpreso: null,
        AgregarRubro : null,
        quitarRubros: [],
      }
    },
    created(){
      this.rutaInhabilitar = this.$route.name == 'CancelacionPagos';
      this.rutaDevolver = this.$route.name == 'DevolucionPagos';
      if(this.$route.name === 'Pagos'){
        this.getFoliosSinImprimir()
      }
    },
    methods: {
    /** 
     * Metodo encargado de llamar API para búscar Pagos en base a los datos proporcionados.
     */
      buscarImputadoAPI: async function() 
      { 
        this.limpiarTablaResultados();
        const parametros = 
        {    
          PartidoJudicialId: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].parametros_PartidoJudicial.partidoJudicialId) ? this.$refs['filtroBusqueda'].parametros_PartidoJudicial.partidoJudicialId : null,
          MateriaId: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].parametros_Materia.materiaId) ? this.$refs['filtroBusqueda'].parametros_Materia.materiaId : null,
          AreaId: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].parametros_Area.areaId) ? this.$refs['filtroBusqueda'].parametros_Area.areaId : null,
          TipoDeDocumentoId: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].parametros_TipoDocumento.tipoDocumentoId) ? this.$refs['filtroBusqueda'].parametros_TipoDocumento.tipoDocumentoId : null,
          Consecutivo: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].consecutivo) ? this.$refs['filtroBusqueda'].consecutivo : null,

          Nombre:  this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].nombre) ? this.$refs['filtroBusqueda'].nombre : null,
          ApellidoPaterno: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].apellido_paterno) ? this.$refs['filtroBusqueda'].apellido_paterno : null,
          ApellidoMaterno: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].apellido_materno) ? this.$refs['filtroBusqueda'].apellido_materno : null,

          Fecha : this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].fecha) ? this.$refs['filtroBusqueda'].fecha : null,

          RubroId: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].parametros_Rubro.rubroId) ? this.$refs['filtroBusqueda'].parametros_Rubro.rubroId : null,   
          Folio: this.campoRequeridoEsValido(this.$refs['filtroBusqueda'].folioBusqueda)  ?  this.$refs['filtroBusqueda'].folioBusqueda : null,
          devolver : this.rutaDevolver                             
          
        }
        if(this.validarBusquedaPago(parametros))
        {
          comun.SeEstaCargandoInformacion(true); 
         
          if(this.rutaInhabilitar){
            var conexion = api.SIVAC.sistema.caja.pagos.BuscarPagosCancelar
          }
          else if(this.rutaDevolver){
            var conexion = api.SIVAC.sistema.caja.pagos.BuscarPagosDevolver
          }
          else{
            var conexion = api.SIVAC.sistema.caja.pagos.BuscarPagos
          }

          const { CON_ERROR, RESPUESTA }  = await Promise.resolve(servicioRestPost({
            servicioUrl: conexion,
            peticionServicio: parametros,
            headers: { TOKEN_AUTORIZACION:this.$store.state.Login_AutorizacionOriginal, HEADER_PARA_ENVIO_ARCHIVOS: false, HEADER_PARA_ARRAY_BUFFER: false }
          }));

          if(!RESPUESTA.Error) {
            //Cargar Datos de Pagos
            this.limpiarTablaResultados();
            //this.contRenderEditar += 5;
            //this.contRenderTablaBusqueda += 17;
            this.contRenderPendientes += 27;
            //console.log('busco')            

            this.Pagos = RESPUESTA.Pagos;
            //comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
          }
          else{         
              console.log(RESPUESTA); 

              this.limpiarTablaResultados();
              comun.mensajeDeAlerta(RESPUESTA.Error.Mensaje, null, null);
          }

        }
      },

      validarDatosBusquedaImputado: function(datos)
      { 
        if(datos.Expediente.AreaId == null || datos.Expediente.AreaId == -1) { //Verifica área
          comun.mensajeDeAlerta("Favor de indicar el área.", null, null);
          return false;
        }
        // if(datos.Expediente.CarpetaDeEjecucion == null || datos.Expediente.CarpetaDeEjecucion == -1){
        //   comun.mensajeDeAlerta("Favor de indicar el numero de carpeta de ejecucion.", null, null);
        //   return false;
        // }
        if(datos.Expediente.Consecutivo == null || datos.Expediente.Consecutivo == -1){
          comun.mensajeDeAlerta("Favor de indicar el consecutivo.", null, null);
          return false;
        }
        else if(datos.Expediente.Consecutivo.length < 9){
          comun.mensajeDeAlerta("Favor de indicar el consecutivo completo", null, null);
          return false;
        }
        if(datos.Expediente.MateriaId == null || datos.Expediente.MateriaId == -1) { //Verifica Materia
          comun.mensajeDeAlerta("Favor de indicar la materia.", null, null);
          return false;
        }
        if(datos.Expediente.PartidoJudicialId == null || datos.Expediente.PartidoJudicialId == -1){
          comun.mensajeDeAlerta("Favor de indicar el partido judicial.", null, null);
          return false;
        }
        if(datos.Expediente.TipoDocumentoId == null || datos.Expediente.TipoDocumentoId == -1) { //verifica tipo de documento
          comun.mensajeDeAlerta("Favor de indicar el tipo de documento.", null, null);
          return false;
        }  
        if(datos.Rubro.Folio<=0 || datos.Rubro.Folio == null){
          comun.mensajeDeAlerta("Error al cargar el folio, recargue la pagina");
          return false;
        }
        if(datos.Rubro.Monto<=0 || datos.Rubro.Monto == null){
          comun.mensajeDeAlerta("Favor de indicar el monto", null, null);
          return false;
        }
        if(datos.Rubro.Telefono== null || datos.Rubro.Telefono == -1){
          comun.mensajeDeAlerta("Favor de indicar el telefono", null, null);
          return false;
        }
        if(datos.Rubro.TipoRubroId== null || datos.Rubro.TipoRubroId == -1){
          comun.mensajeDeAlerta("Favor de indicar el concepto", null, null);
          return false;
        }
        if(datos.Persona.Nombre == null || datos.Persona.Nombre == undefined){
          comun.mensajeDeAlerta("Favor de indicar el nombre", null, null);
          return false;
        }
        if(datos.Rubro.Telefono.length < 10){
          comun.mensajeDeAlerta("El telefono debe tener al menos 10 digitos", null, null);
          return false;
        }  
        // if(datos.Persona.ApellidoPaterno == null || datos.Persona.ApellidoPaterno == undefined){
        //   comun.mensajeDeAlerta("Favor de indicar el apellido paterno", null, null);
        //   return false;
        // }
        // if(datos.Persona.ApellidoMaterno == null || datos.Persona.ApellidoMaterno == undefined){
        //   comun.mensajeDeAlerta("Favor de indicar el apellido materno", null, null);
        //   return false;
        // }
        // else if(datos.Expediente.CarpetaDeEjecucion.length < 9){
        //   comun.mensajeDeAlerta("Favor de indicar el numero de carpeta de ejecucion completo", null, null);
        //   return false;
        // }
        return true;
       },

       validarBusquedaPago: function(datos){
          if ((datos.Folio == null || datos.Folio <= 0)
              && (datos.Nombre == null || datos.Nombre == undefined)
              && (datos.ApellidoPaterno == null || datos.ApellidoPaterno == undefined)
              && (datos.ApellidoMaterno == null || datos.ApellidoMaterno == undefined)
              && (datos.Fecha == null || datos.Fecha == undefined)) {
            comun.mensajeDeAlerta("Favor de ingresar por lo menos un campo", null, null);
            return false;
          }
          return true;
       },

       validarDatosBusquedaDevolucion: function(datos){


            if(datos.Devoluciones.TipoBancoId == null || datos.Devoluciones.TipoBancoId == -1){
                comun.mensajeDeAlerta("Favor de indicar el banco", null, null);
                return false;
            }
            if(datos.Devoluciones.NumeroOficioJuzgado == null || datos.Devoluciones.NumeroOficioJuzgado == -1){
                comun.mensajeDeAlerta("Favor de indicar el numero de oficio del juzgado", null, null);
                return false;
            }
            else if(datos.Devoluciones.NumeroOficioJuzgado.length < 9){
                comun.mensajeDeAlerta("Favor de indicar el numero de oficio del juzgado completo", null, null);
                return false;
            }
            if(datos.Devoluciones.NumeroCheque == null || datos.Devoluciones.NumeroCheque <= 0){
                comun.mensajeDeAlerta("Favor de indicar el numero de cheque", null, null);
                return false;
            }
            if(datos.Devoluciones.MontoDevolucion == null || datos.Devoluciones.MontoDevolucion <= 0){
                comun.mensajeDeAlerta("Favor de indicar un monto valido", null, null);
                return false;
            }
            if(datos.Devoluciones.NumeroOficioOficialia == null || datos.Devoluciones.NumeroOficioOficialia == -1){
                comun.mensajeDeAlerta("Favor de indicar el numero de oficio de oficialia", null, null);
                return false;
            }
            else if(datos.Devoluciones.NumeroOficioOficialia.length < 9){
                comun.mensajeDeAlerta("Favor de indicar el numero de oficio de oficialia completo", null, null);
                return false;
            }
            if(datos.Devoluciones.PuestoDestinatarioId == null || datos.Devoluciones.PuestoDestinatarioId == -1){
                comun.mensajeDeAlerta("Favor de indicar el puesto del destinatario", null, null);
                return false;
            }
            if(datos.Devoluciones.PuestoRemitenteId == null || datos.Devoluciones.PuestoRemitenteId == -1){
                comun.mensajeDeAlerta("Favor de indicar el puesto del remitente", null, null);
                return false;
            }
            if(datos.Devoluciones.TituloDestinatarioId == null || datos.Devoluciones.TituloDestinatarioId == -1){
                comun.mensajeDeAlerta("Favor de indicar el titulo del destinatario", null, null);
                return false;
            }
            if(datos.Devoluciones.TituloRemitenteId == null || datos.Devoluciones.TituloRemitenteId == -1){
                comun.mensajeDeAlerta("Favor de indicar el titulo del remitente", null, null);
                return false;
            }
            if(datos.Devoluciones.NombreDestinatario == null || datos.Devoluciones.NombreDestinatario == undefined){
                comun.mensajeDeAlerta("Favor de indicar el nombre del destinatario", null, null);
                return false;
            }
            if(datos.Devoluciones.NombreRemitente == null || datos.Devoluciones.NombreRemitente == undefined){
                comun.mensajeDeAlerta("Favor de indicar el nombre del remitente", null, null);
                return false;
            }
            if(datos.Persona.Nombre == null || datos.Persona.Nombre == undefined){
                comun.mensajeDeAlerta("Favor de indicar el nombre del beneficiario", null, null);
                return false;
            }
            return true;
       },
       /** 
       * Metodo encargado de verificar que el campo proporcionado tenga un valor valido
       * @param {string/int/other} campo [campo]
       */
      campoRequeridoEsValido: function(campo) 
      {
          let esValido = false
          if(typeof campo === 'string' || campo instanceof String) {
              // valida que filtro tipo cadena no sea nula, indefinida y compuestas solo de espacios en blanco o saltos de linea
              if (campo != null && campo != undefined && campo != '' && campo.replace(/\s/g, '').length) {
                  esValido = true;
              }
          }
          else if (typeof campo === 'number' || campo instanceof Number) {
              // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
              if (campo != null && campo != undefined && campo > 0) {
                  esValido = true;
              }
          }
          else {
              if (campo != null && campo != undefined) {
                  esValido = true;
              }
          }
          return esValido;
      },

      esPortador: function (p) {
        this.esAlPortador = p;
      },
       /** 
       * Metodo encargado de limpiar los valores de la tabla de resultados.
       */
      limpiarTablaResultados: function()
      {
        this.Pagos = null;
        this.CargarDevolucion = null;
        this.EditarDevolucion = null;
        this.EditarDatosDevolucion = null;
        this.DevolverPago =  null;
        this.EditarDevolucionPago = null;

        this.accioneseditarpago.editar = false; ///para borrar el componente
        this.accioneseditarpago.agregar = false; 
        this.accionesdevolverpago.devolver = false;
        this.accionesdevolverpago.editar = false;
        this.accionesDevolver.cambiarestatus = false;

        if(this.$route.name === 'Pagos'){
            this.getFoliosSinImprimir()
        }

      }, 
      //////////con esta funcion se busca el pago a editar
      editarPago: async function(rubroId) {
        this.Pagos = null;
        this.rubroId = rubroId;


        const parametros = {
          IDrubro: this.campoRequeridoEsValido(this.rubroId)  ?  this.rubroId : null
        }

        comun.SeEstaCargandoInformacion(true); 

        const { CON_ERROR, RESPUESTA }  = await Promise.resolve(servicioRestPost({
            servicioUrl: api.SIVAC.sistema.caja.pagos.BuscarPagos,
            peticionServicio: parametros,
            headers: { TOKEN_AUTORIZACION:this.$store.state.Login_AutorizacionOriginal, HEADER_PARA_ENVIO_ARCHIVOS: false, HEADER_PARA_ARRAY_BUFFER: false }
        }));

        console.log('response::editarPago::', RESPUESTA)
        if(!RESPUESTA.Error) {
              this.EditarPago = RESPUESTA.Pagos[0];
              this.EditarNombre = RESPUESTA.Pagos[0];

              this.IDEditar.ExpedienteID =  this.EditarPago.ExpedienteId;
              this.IDEditar.PersonaId = this.EditarPago.PersonaId;
              this.IDEditar.RubroId = this.EditarPago.RubroId;

              this.TipoRubroId = this.EditarPago.RubroDBPJ.TipoRubroId;
              this.TipoDocumentoID = this.EditarPago.Expediente.TipoDocumento.TipoDocumentoId;
              this.materiaID = this.EditarPago.Expediente.Materia.MateriaId;

              this.partidoJudicial = this.EditarPago.Expediente.PartidoJudicialId;
              this.areaId = this.EditarPago.Expediente.Area.AreaId
              this.folio = this.EditarPago.Folio;
              this.impreso = this.EditarPago.Impreso;

              console.log('entro::editarPago::IDEditar::' + this.IDEditar.ExpedienteID );

              this.validarImpreso(this.impreso);
              this.rubrosAQuitar(this.folio, this.TipoRubroId);
              //this.contRenderEditar += 3;
              this.setFiltrosEditar(true);
              //se cambia a true para que cargue el div de editar hasta que ya tenga los datos que necesitan un id
              this.accioneseditarpago.editar = true;
              this.quitarRubros = [];
          }
          else {
              this.limpiarTablaResultados();
              comun.mensajeDeAlerta(RESPUESTA.Error.Mensaje, null, null);
          }
      },
      setFiltrosEditar:  function(cargar) {
        console.log('entro::setFiltrosEditar');
        this.$nextTick(()=>{
          this.setSetFiltrosEditar();
        }); 
      },

      setSetFiltrosEditar: function(){
        console.log('entro::setSetFiltrosEditar');
        this.$nextTick(() => {
          this.$refs['filtroEditar'].monto = this.EditarPago.Monto;
          this.$refs['filtroEditar'].nombre = this.EditarNombre.Nombre;
          if(this.$refs['filtroEditar'].nombre == "AL PORTADOR"){///empatar con el que aparece en altacaja.vue
              this.$refs['filtroEditar'].persona = true;
          }
          this.$refs['filtroEditar'].apellido_paterno = this.EditarNombre.ApellidoPaterno;
          this.$refs['filtroEditar'].apellido_materno = this.EditarNombre.ApellidoMaterno;
          this.$refs['filtroEditar'].consecutivo = this.EditarPago.Expediente.Consecutivo;
          this.$refs['filtroEditar'].numeroRomano = this.EditarPago.Expediente.NumeroRomano;
          this.$refs['filtroEditar'].telefono = this.EditarPago.Telefono;

          this.$refs['filtroEditar'].observaciones = this.EditarPago.Observaciones;
          if(this.$refs['filtroEditar'].observaciones != null){
            this.$refs['filtroEditar'].observacionescheck = true;
          }
        });
      },

      agregarRubro: async function(rubroId){   //retomar 

          this.Pagos = null;
          this.rubroId = rubroId;

          const parametros = {
            IDrubro: this.campoRequeridoEsValido(this.rubroId)  ?  this.rubroId : null
          }

          comun.SeEstaCargandoInformacion(true); 

          const { CON_ERROR, RESPUESTA }  = await Promise.resolve(servicioRestPost({
            servicioUrl: api.SIVAC.sistema.caja.pagos.BuscarPagos,
            peticionServicio: parametros,
            headers: { TOKEN_AUTORIZACION:this.$store.state.Login_AutorizacionOriginal, HEADER_PARA_ENVIO_ARCHIVOS: false, HEADER_PARA_ARRAY_BUFFER: false }
          }));

          
          if(!RESPUESTA.Error) {
              this.AgregarRubro = RESPUESTA.Pagos[0];
              this.AgregarNombre = RESPUESTA.Pagos[0];

              this.IDAgregar.ExpedienteID =  this.AgregarRubro.ExpedienteId;
              this.IDAgregar.PersonaId = this.AgregarRubro.PersonaId;
              this.IDAgregar.RubroId = this.AgregarRubro.RubroId;

              //this.TipoRubroId = this.AgregarRubro.RubroDBPJ.TipoRubroId;
              this.TipoDocumentoID = this.AgregarRubro.Expediente.TipoDocumento.TipoDocumentoId;
              this.materiaID = this.AgregarRubro.Expediente.Materia.MateriaId;

              this.partidoJudicial = this.AgregarRubro.Expediente.PartidoJudicialId;
              this.areaId = this.AgregarRubro.Expediente.Area.AreaId
              this.folio = this.AgregarRubro.Folio;
              this.impreso = this.AgregarRubro.Impreso;

              console.log('entro::agregarRubro::IDAgregar::' + this.IDAgregar.ExpedienteID );

              this.validarImpreso(this.impreso);

              this.accioneseditarpago.agregar = true;
              this.contRenderAgregar += 8;
              this.setFiltrosAgregar();
              /*this.quitarRubros = */this.rubrosAQuitar(this.folio);
              this.quitarRubros = [];

          }
          else {
              this.limpiarTablaResultados();
              comun.mensajeDeAlerta(RESPUESTA.Error.Mensaje, null, null);
          }

      },      

      setFiltrosAgregar : function() {
        console.log('entro::setFiltrosAgregar');
        this.$nextTick(() => {
          //this.$refs['filtroAgregar'].monto = this.AgregarRubro.Monto;
          this.$refs['filtroAgregar'].nombre = this.AgregarNombre.Nombre;
          if(this.$refs['filtroAgregar'].nombre == "AL PORTADOR"){///empatar con el que aparece en altacaja.vue
              this.$refs['filtroAgregar'].persona = true;
          }
          this.$refs['filtroAgregar'].apellido_paterno = this.AgregarNombre.ApellidoPaterno;
          this.$refs['filtroAgregar'].apellido_materno = this.AgregarNombre.ApellidoMaterno;
          this.$refs['filtroAgregar'].consecutivo = this.AgregarRubro.Expediente.Consecutivo;
          this.$refs['filtroAgregar'].numeroRomano = this.AgregarRubro.Expediente.NumeroRomano;
          this.$refs['filtroAgregar'].telefono = this.AgregarRubro.Telefono;

          this.$refs['filtroAgregar'].observaciones = this.AgregarRubro.Observaciones;
          if(this.$refs['filtroAgregar'].observaciones != null){
            this.$refs['filtroAgregar'].observacionescheck = true;
          }

        });
      },

      inhabilitarPago : function(folio){
        var inhabilitarcaja = this;
        var locale = {
            OK: '<i class="fa fa-check"></i>&nbsp;&nbsp;Si',
            CONFIRM: '<i class="fa fa-check"></i>&nbsp;&nbsp;Si',
            CANCEL: '<i class="fa fa-times"></i>&nbsp;&nbsp;No'
        };
            
        bootbox.addLocale('custom', locale);


        bootbox.prompt({
          title: "Mensaje del sistema",
          message: "ADVERTENCIA. Está a punto de inhabilitar el pago con el folio: " + folio + 
                    "<br><br> ¿Esta seguro de querer realizar esta acción? Al inhabilitarlo no se asignara de nuevo el folio.<br><br> Ingrese Motivo",
          locale: 'custom',

          callback: (confirmar)=>{
            if(confirmar){

            const parametros = {
              Folio : folio,
              Observaciones: confirmar.toUpperCase()
            }

              comun.SeEstaCargandoInformacion(true);
                    
              const headerPeticion = comun.CrearElHeaderDeAutorizacion(inhabilitarcaja.$store.state.Login_AutorizacionOriginal, false); 
              axios.post(api.conexion + api.SIVAC.sistema.caja.pagos.InhabilitarPagos, parametros, headerPeticion)
                    .then(respuesta => {
                          comun.SeEstaCargandoInformacion(false);
                          if(respuesta.data.SiHayError) {
                            console.log(respuesta);
                            comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                          } else {
                            inhabilitarcaja.limpiarTablaResultados();
                            comun.mensajeDeAlerta('Pago Inhabilitado Correctamente', null, null);
                          }         
                    })
                    .catch(e => {
                      comun.SeEstaCargandoInformacion(false);
                      console.log("No Hay Respuesta del Servidor" + e);
                      comun.mensajeDeAlerta(comun.mensajeDeError(inhabilitarcaja.enumeraciones.error.E500), null, null);
                    });
            }
            else{
              if(confirmar == ''){
                  comun.mensajeDeAlerta('No se inhabilito el pago, ingrese el motivo', null, null);
              }
            }

          }
        });

      },

      cargarPagoDevolver : async function(rubroId, devuelto){

        this.Pagos = null;
        this.rubroId = rubroId;
        this.folio = 0;

        this.totalDevuelto = devuelto;
        this.quitarMenuEstatus();

        const parametros = {
          IDrubro: this.campoRequeridoEsValido(this.rubroId)  ?  this.rubroId : null,
        }

        comun.SeEstaCargandoInformacion(true); 

        const { CON_ERROR, RESPUESTA }  = await Promise.resolve(servicioRestPost({
            servicioUrl: api.SIVAC.sistema.caja.pagos.BuscarPagosDevolver,
            peticionServicio: parametros,
            headers: { TOKEN_AUTORIZACION:this.$store.state.Login_AutorizacionOriginal, HEADER_PARA_ENVIO_ARCHIVOS: false, HEADER_PARA_ARRAY_BUFFER: false }
        }));

        if(!RESPUESTA.Error) {
          //Cargar Datos de Pagos

          this.DevolverPago = RESPUESTA.Pagos[0];

          //this.DevolverNombre = respuesta.data.Pagos[0].Devoluciones[0].Persona;
          this.TotalMonto = this.DevolverPago.Monto;

          this.folio = this.DevolverPago.Folio;
          this.TipoRubroId = this.DevolverPago.RubroDBPJ.TipoRubroId;
          this.TipoDocumentoID = this.DevolverPago.Expediente.TipoDocumento.TipoDocumentoId; 

          this.partidoJudicial = this.DevolverPago.Expediente.PartidoJudicialId;

          this.materiaID = this.DevolverPago.Expediente.Materia.MateriaId;
          this.areaId = this.DevolverPago.Expediente.Area.AreaId;
          this.expedienteId = this.DevolverPago.ExpedienteId;

          this.accionesdevolverpago.devolver = true;

          this.setcargarPagoDevolver();
        }
        else{              
            this.limpiarTablaResultados();
            comun.mensajeDeAlerta(RESPUESTA.Error.Mensaje, null, null);
        }

      },

      setcargarPagoDevolver: async function(){
        this.$nextTick(async ()=>{
          if(this.expedienteId > 0){
              const parametros = {
                ExpedienteId : this.campoRequeridoEsValido(this.expedienteId) ? this.expedienteId : null
              }

              comun.SeEstaCargandoInformacion(true); 


              const { CON_ERROR, RESPUESTA }  = await Promise.resolve(servicioRestPost({
                servicioUrl: api.SIVAC.sistema.caja.pagos.BuscarDevolucion,
                peticionServicio: parametros,
                headers: { TOKEN_AUTORIZACION:this.$store.state.Login_AutorizacionOriginal, HEADER_PARA_ENVIO_ARCHIVOS: false, HEADER_PARA_ARRAY_BUFFER: false }
                }));

              if(!RESPUESTA.dev) {

                this.CargarDevolucion = null;
                this.CargarDevolucion = RESPUESTA.Pagos[0].Devoluciones[0];
                       
                this.tituloremitenteId = this.CargarDevolucion.TituloRemitenteId;
                this.puestodestinatarioId = this.CargarDevolucion.PuestoDestinatarioId;
                this.titulodestinatarioId = this.CargarDevolucion.TituloDestinatarioId;
                this.puestoremitenteId = this.CargarDevolucion.PuestoRemitenteId;
                this.contRenderDevolucion += 3;
                this.setOficioDevolucion(RESPUESTA);
              
              }
              else{          

                this.CargarDevolucion = RESPUESTA.dev;

                this.tituloremitenteId = 1 ////de aqui
                this.puestodestinatarioId = -1
                this.titulodestinatarioId = 1
                this.puestoremitenteId = 498

                this.contRenderDevolucion += 3;
                this.setConsecDevolucion()
              }

            }
        })
      },

      setOficioDevolucion :  function(oficio){
        this.$nextTick( ()=>{
          
          
          if(oficio.Pagos[0].Folio != this.folio){
              this.$refs['filtroDevolver'].nombre = this.CargarDevolucion.Persona.Nombre;
              this.$refs['filtroDevolver'].apellido_paterno = this.CargarDevolucion.Persona.ApellidoPaterno;
              this.$refs['filtroDevolver'].apellido_materno = this.CargarDevolucion.Persona.ApellidoMaterno; 
              this.$refs['filtroDevolver'].parametros_Oficio.numeroOficioJuzgado = this.CargarDevolucion.NumeroOficioJuzgado;
              this.$refs['filtroDevolver'].parametros_Oficio.cheque = this.CargarDevolucion.NumeroCheque;
              this.$refs['filtroDevolver'].parametros_Oficio.numeroOficioOficialia = this.CargarDevolucion.NumeroOficioOficialia;
          }

          this.$refs['filtroDevolver'].consecutivo = this.DevolverPago.Expediente.Consecutivo;
          this.$refs['filtroDevolver'].numeroRomano = this.DevolverPago.Expediente.NumeroRomano;

          this.$refs['filtroDevolver'].parametros_Oficio.nombreRemitente = this.CargarDevolucion.NombreRemitente;
          this.$refs['filtroDevolver'].parametros_Oficio.nombreDestinatario = this.CargarDevolucion.NombreDestinatario;
          this.deshabilitarDevolver(true)
        })
      },

      setConsecDevolucion :  function(){
        this.$nextTick( ()=>{
          this.$refs['filtroDevolver'].consecutivo = this.DevolverPago.Expediente.Consecutivo;
          this.$refs['filtroDevolver'].numeroRomano = this.DevolverPago.Expediente.NumeroRomano;
          
          this.deshabilitarDevolver(true)
        })
      },

     
      devolverPago:function(){
        const parametros = 
        {
              Devoluciones:{
                  TipoBancoId: this.$refs['filtroDevolver'].parametros_Banco.bancoId,
                  NumeroOficioJuzgado: this.$refs['filtroDevolver'].parametros_Oficio.numeroOficioJuzgado, 
                  NumeroCheque: this.$refs['filtroDevolver'].parametros_Oficio.cheque,
                  MontoDevolucion: this.$refs['filtroDevolver'].monto,
                  NumeroOficioOficialia: this.$refs['filtroDevolver'].parametros_Oficio.numeroOficioOficialia,
                  PuestoDestinatarioId: this.$refs['filtroDevolver'].parametros_PuestoDestinatario.puestoId,
                  TituloDestinatarioId: this.$refs['filtroDevolver'].parametros_TituloDestinatario.tituloId,
                  NombreDestinatario: this.$refs['filtroDevolver'].parametros_Oficio.nombreDestinatario,
                  PuestoRemitenteId: this.$refs['filtroDevolver'].parametros_PuestoRemitente.puestoId,
                  TituloRemitenteId: this.$refs['filtroDevolver'].parametros_TituloRemitente.tituloId,
                  NombreRemitente: this.$refs['filtroDevolver'].parametros_Oficio.nombreRemitente,
                  Observaciones: this.$refs['filtroDevolver'].observacionesdevolucion,
                  FechadeDevolucion: this.$refs['filtroDevolver'].fechaDevolucion,
                  AreaDestinatarioOficioId: this.$refs['filtroDevolver'].parametros_Oficio.areaDestinatarioId

              },
              Persona:{
                  Nombre:  this.$refs['filtroDevolver'].nombre,
                  ApellidoPaterno: this.$refs['filtroDevolver'].apellido_paterno,
                  ApellidoMaterno: this.$refs['filtroDevolver'].apellido_materno,
              },
              rubroId : this.rubroId

        }
      if(this.validarDatosBusquedaDevolucion(parametros)){
        comun.SeEstaCargandoInformacion(true); 
        const headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false);

        axios.post(api.conexion + api.SIVAC.sistema.caja.pagos.DevolverPagos, parametros, headerPeticion)
          .then(respuesta => {
            comun.SeEstaCargandoInformacion(false);
            if (respuesta.data.SiHayError) {
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else {
              comun.mensajeDeAlerta('Se registró pago a devolver', null, null);
              this.limpiarTablaResultados();
              this.buscarImputadoAPI()

              // descomentar si hace falta agregar varios al mismo rubro, borrar si no 
              // var altaDevolucion = this;
              // bootbox.dialog({
              //   title: "Mensaje del sistema",
              //   message: respuesta.data.Satisfactorio + ' Desea agregar otra devolucion al mismo rubro?',
              //   buttons:{
              //     cancel: {
              //       label: '<i class="fa fa-times"></i>&nbsp;&nbsp;' + "No",
              //       className: 'btn-danger float-right',
              //       callback: function(){
              //         altaDevolucion.limpiarTablaResultados();
              //         altaDevolucion.buscarImputadoAPI()
              //       }

              //     },
              //     confirm: {
              //       label: '<i class="fa fa-check"></i>&nbsp;&nbsp;' + "Sí",
              //       className: 'btn-success',
              //       callback: function(){
              //         altaDevolucion.limpiarFiltrosDevolucion();
              //       }
              //     }
              //   }
              // });

              //comun.mensajeDeAlerta('Se registró pago a devolver', null, null);
            }
          })
          .catch(e => {
            comun.SeEstaCargandoInformacion(false);
            console.log("No Hay Respuesta del Servidor" + e);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
          });
        }

      },

      editarDevolucion: async function(devolucion, rubro, devuelto){
        console.log('entro::editarDevolucion');
        this.totalDevuelto = devuelto;

        this.limpiarTablaResultados();
        this.accionesdevolverpago.editar = true;

        this.Pagos = null;

        const parametros = {
          DevolucionId: this.campoRequeridoEsValido(devolucion)  ?  devolucion : null,
          RubroId: this.campoRequeridoEsValido(rubro)  ?  rubro : null,
        }

        comun.SeEstaCargandoInformacion(true); 
        
        const { CON_ERROR, RESPUESTA }  = await Promise.resolve(servicioRestPost({
                servicioUrl: api.SIVAC.sistema.caja.pagos.BuscarDevolucion,
                peticionServicio: parametros,
                headers: { TOKEN_AUTORIZACION:this.$store.state.Login_AutorizacionOriginal, HEADER_PARA_ENVIO_ARCHIVOS: false, HEADER_PARA_ARRAY_BUFFER: false }
        }));

        if(!RESPUESTA.Error) {

          this.EditarDevolucion = RESPUESTA.Pagos[0];
          this.EditarDatosDevolucion = RESPUESTA.Pagos[0].Devoluciones[0];

          this.devolucionId = this.EditarDatosDevolucion.DevolucionId;

          this.IDEditar.PersonaId = RESPUESTA.Pagos[0].PersonaId;
          this.IDEditar.RubroId = this.EditarDevolucion.RubroId;
                
          this.areaId = this.EditarDevolucion.Expediente.Area.AreaId
          this.TipoRubroId = this.EditarDevolucion.RubroDBPJ.TipoRubroId;
          this.TipoDocumentoID = this.EditarDevolucion.Expediente.TipoDocumento.TipoDocumentoId;

          this.partidoJudicial = this.EditarDevolucion.Expediente.PartidoJudicialId;

          this.materiaID = this.EditarDevolucion.Expediente.Materia.MateriaId;
          this.folio = this.EditarDevolucion.Folio;

          this.bancoId = this.EditarDatosDevolucion.TipoBanco.TipoBancoId;

          this.puestoremitenteId = this.EditarDatosDevolucion.PuestoRemitenteId;
          this.tituloremitenteId= this.EditarDatosDevolucion.TituloRemitenteId;

          this.puestodestinatarioId = this.EditarDatosDevolucion.PuestoDestinatarioId;
          this.titulodestinatarioId= this.EditarDatosDevolucion.TituloDestinatarioId;
          //console.log(this.EditarDatosDevolucion)
          this.areadestinatarioId = this.EditarDatosDevolucion.AreaDestinatarioOficio.AreaId;

          this.contRenderEdicionDevolucion += 6;
          //await Promise.resolve(this.deshabilitarDevolver(true))

          this.setEditarDevolucion()


        }

        else{              
            this.limpiarTablaResultados();
            comun.mensajeDeAlerta(RESPUESTA.Error.Mensaje, null, null);
        }

      },

      setEditarDevolucion: function(){
        this.$nextTick( ()=>{
          this.$refs['filtroEditarDevolucion'].telefono = this.EditarDevolucion.Telefono;
          this.$refs['filtroEditarDevolucion'].observaciones = this.EditarDevolucion.Observaciones;

          this.TotalMonto = this.EditarDevolucion.Monto;
          this.$refs['filtroEditarDevolucion'].consecutivo = this.EditarDevolucion.Expediente.Consecutivo;
          this.$refs['filtroEditarDevolucion'].numeroRomano = this.EditarDevolucion.Expediente.NumeroRomano;
                        
          this.$refs['filtroEditarDevolucion'].nombre = this.EditarDatosDevolucion.Persona.Nombre;
          this.$refs['filtroEditarDevolucion'].apellido_paterno = this.EditarDatosDevolucion.Persona.ApellidoPaterno;
          this.$refs['filtroEditarDevolucion'].apellido_materno = this.EditarDatosDevolucion.Persona.ApellidoMaterno;
              
          this.$refs['filtroEditarDevolucion'].monto = this.EditarDatosDevolucion.MontoDevolucion;

          this.$refs['filtroEditarDevolucion'].parametros_Oficio.numeroOficioJuzgado = this.EditarDatosDevolucion.NumeroOficioJuzgado;
          this.$refs['filtroEditarDevolucion'].parametros_Oficio.cheque = this.EditarDatosDevolucion.NumeroCheque;
                //$('#cheque').attr('disabled', 'disabled');
          this.$refs['filtroEditarDevolucion'].parametros_Oficio.numeroOficioOficialia = this.EditarDatosDevolucion.NumeroOficioOficialia;
          this.$refs['filtroEditarDevolucion'].fechaDevolucion = this.EditarDatosDevolucion.FechadeDevolucion.split('T')[0];
              ///remitente
          this.$refs['filtroEditarDevolucion'].parametros_Oficio.nombreRemitente = this.EditarDatosDevolucion.NombreRemitente;

             ///destinatario

          this.$refs['filtroEditarDevolucion'].parametros_Oficio.nombreDestinatario = this.EditarDatosDevolucion.NombreDestinatario;
          this.$refs['filtroEditarDevolucion'].observacionesdevolucion = this.EditarDatosDevolucion.Observaciones;
          if(this.$refs['filtroEditarDevolucion'].observacionesdevolucion != null){
              this.$refs['filtroEditarDevolucion'].observacionesdevolucioncheck = true;
          }
          this.$refs['filtroEditarDevolucion'].parametros_Oficio.areaDestinatarioId = this.EditarDatosDevolucion.AreaDestinatarioOficio.AreaId;
          if(this.$refs['filtroEditarDevolucion'].parametros_Oficio.areaDestinatarioId != null && this.$refs['filtroEditarDevolucion'].parametros_Oficio.areaDestinatarioId > 0){
            this.$refs['filtroEditarDevolucion'].checkJuzgadoDestinatario = true;
          }
          this.deshabilitarDevolver(true)
        });
      },

     
      eliminarDevolucion: function(devolucionId, monto, folio){
        
        var devolucionCaja = this;
        const parametros = {
          DevolucionId : devolucionId
        }

        bootbox.dialog({
          title: "Mensaje del sistema",
          message: "ADVERTENCIA. Está a punto de eliminar la devolucion con el monto registrado de : $" + this.agregarCeros(monto) + 
                    " del folio: "+ folio +" ¿Esta seguro de querer realizar esta acción? ",
          buttons: {
            cancel: {
              label: '<i class="fa fa-times"></i>&nbsp;&nbsp;' + "No",
              className: 'btn-danger float-right',
                callback: function(){
                    console.log('no cancelar')
                }

            },
            confirm: {
              label: '<i class="fa fa-check"></i>&nbsp;&nbsp;' + "Sí",
              className: 'btn-success',
                callback: function(){
                    comun.SeEstaCargandoInformacion(true);
                    
                    const headerPeticion = comun.CrearElHeaderDeAutorizacion(devolucionCaja.$store.state.Login_AutorizacionOriginal, false); 
                    axios.post(api.conexion + api.SIVAC.sistema.caja.pagos.EliminarDevolucionPagos, parametros, headerPeticion)
                    .then(respuesta => {
                          comun.SeEstaCargandoInformacion(false);
                          if(respuesta.data.SiHayError) {
                            console.log(respuesta);
                            comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                          } else {
                            devolucionCaja.buscarImputadoAPI();

                            comun.mensajeDeAlerta('Devolucion Eliminada Correctamente', null, null);
                          }         
                    })
                    .catch(e => {
                      comun.SeEstaCargandoInformacion(false);
                      console.log("No Hay Respuesta del Servidor" + e);
                      comun.mensajeDeAlerta(comun.mensajeDeError(devolucionCaja.enumeraciones.error.E500), null, null);
                    });
                }
            }
          }
        });

      },


      cancelar: function(){
        this.limpiarTablaResultados();
      },

      getFoliosSinImprimir: async function(){
          const parametros = {};
    
          const { CON_ERROR, RESPUESTA }  = await Promise.resolve(servicioRestPost({
            servicioUrl: api.SIVAC.sistema.administracion.pagos.GetFoliosSinImprimir,
            peticionServicio: parametros,
            headers: { TOKEN_AUTORIZACION:this.$store.state.Login_AutorizacionOriginal, HEADER_PARA_ENVIO_ARCHIVOS: false, HEADER_PARA_ARRAY_BUFFER: false }
            }));
            if(!RESPUESTA.Error) {
              this.ultimoFolioNoImpreso = RESPUESTA.ultimoFolioNoImpreso;
              this.foliosSinImprimir = RESPUESTA.foliosSinImprimir;
            }
            else{              
              console.log(RESPUESTA);
              comun.mensajeDeAlerta(RESPUESTA.Error.Mensaje, null, null);
          }  
        },

        rubrosAQuitar: async function(folio, TipoRubroId){
          const parametros = {
            Folio: this.campoRequeridoEsValido(folio) ? folio : null
          }
          comun.SeEstaCargandoInformacion(true);

          const { CON_ERROR, RESPUESTA }  = await Promise.resolve(servicioRestPost({
            servicioUrl: api.SIVAC.sistema.caja.pagos.BuscarPagos,
            peticionServicio: parametros,
            headers: { TOKEN_AUTORIZACION:this.$store.state.Login_AutorizacionOriginal, HEADER_PARA_ENVIO_ARCHIVOS: false, HEADER_PARA_ARRAY_BUFFER: false }
          }));

          if(!RESPUESTA.Error) {
            //Cargar Datos de Pagos

            Object.keys(RESPUESTA.Pagos).forEach((key)=>{
              this.quitarRubros.push(RESPUESTA.Pagos[key].RubroDBPJ.TipoRubroId)
            });

            this.quitarRubros = this.quitarRubros.filter(item => item !== TipoRubroId)

            if(this.$refs['filtroAgregar'] !== undefined){
              this.$refs['filtroAgregar'].parametros_Rubro.key += 1; ///sin esto no actualuza los rubros  disponibles
              this.$refs['filtroAgregar'].parametros_Rubro.rubroId = -1;
              this.inhabilitarCamposAgregar();
            }
            if(this.$refs['filtroEditar'] !== undefined){
              this.$refs['filtroEditar'].parametros_Rubro.key += 1; ///sin esto no actualuza los rubros  disponibles
              this.$refs['filtroEditar'].parametros_Rubro.rubroId = TipoRubroId;
            }

          }
          else{              
            this.limpiarTablaResultados();
            comun.mensajeDeAlerta(RESPUESTA.Error.Mensaje, null, null);
          } 
        },

        inhabilitarCamposAgregar: function(){
            $("#filtroDeBusqueda_Area").attr('disabled','disabled');  
            $("#filtroDeBusqueda_PartidoJudicial").attr('disabled','disabled');
            $("#filtroDeBusqueda_Materia").attr('disabled','disabled');
            $("#filtroDeBusqueda_TipoDocumento").attr('disabled','disabled');
            $("#Consecutivo").attr('disabled','disabled');
            $("#numeroRomano").attr('disabled','disabled');
            $("#telefono").attr('disabled','disabled');
            $("#observaciones").attr('disabled', 'disabled');
            $("#observacionescheck").attr('disabled', 'disabled');
            $("#persona").attr('disabled', 'disabled');

            $(".persona").attr('disabled','disabled');
          
        },

      imprimirRecibo: async function(folio){

        //this.buscarImputadoFolio(folio);

        const parametros = 
        {  
          Folio: this.campoRequeridoEsValido(folio)  ?  folio : null                           
        }

        comun.SeEstaCargandoInformacion(true);

        const { CON_ERROR, RESPUESTA }  = await Promise.resolve(servicioRestPost({
            servicioUrl: api.SIVAC.sistema.caja.pagos.BuscarPagos,
            peticionServicio: parametros,
            headers: { TOKEN_AUTORIZACION:this.$store.state.Login_AutorizacionOriginal, HEADER_PARA_ENVIO_ARCHIVOS: false, HEADER_PARA_ARRAY_BUFFER: false }
        }));

        if(!RESPUESTA.Error) {
            //Cargar Datos de Pagos
            this.PagosAImprimir  = RESPUESTA.Pagos;

            this.cargarMensajeImprimirRecibo(folio);
        }
        else{              
            this.limpiarTablaResultados();
            comun.mensajeDeAlerta(RESPUESTA.Error.Mensaje, null, null);
        }        

      },

      cargarMensajeImprimirRecibo: function(folio){
        this.$nextTick(()=>{
          var altacaja = this;
          var recibo = altacaja.PagosAImprimir[0]
          var pagoGeneral = recibo;
          var nombre = recibo.Nombre + ' ' +  ((recibo.ApellidoPaterno != null) ? recibo.ApellidoPaterno : '') + ' ' + ((recibo.ApellidoMaterno != null) ?  recibo.ApellidoMaterno : '');
          var conceptos = "";

          altacaja.PagosAImprimir.forEach((Pago) =>{
              
                conceptos += ("" + Pago.RubroDBPJ.Nombre + ": $" + this.agregarCeros(Pago.Monto) + "<br>");
              
          });

          var impreso = pagoGeneral.Impreso;

          if(!impreso){
            bootbox.dialog({
            title: "Mensaje del sistema",
            message: "Desea imprimir el recibo? Al presionar Si ya no se podra hacer ninguna modificacion <br><br>" + 
                   "Juzgado: " + pagoGeneral.Expediente.Area.Nombre + "<br>" + 
                   "Consecutivo: " + pagoGeneral.Expediente.Consecutivo + ((pagoGeneral.Expediente.NumeroRomano != null) ? '-' + pagoGeneral.Expediente.NumeroRomano : '') +"<br>" + 
                   "Tipo Doc: " + pagoGeneral.Expediente.TipoDocumento.Nombre+"<br>" + 
                   "Nombre: " + nombre + "<br>" +
                   "Telefono: " + pagoGeneral.Telefono + "<br>" +
                   (pagoGeneral.Observaciones ? "Observaciones: " + pagoGeneral.Observaciones + "<br>" : '')  +
                   "<br>Conceptos: " + "<br>" + conceptos + "<br>",
            buttons: {
              cancel: {
                label: '<i class="fa fa-times"></i>&nbsp;&nbsp;' + "No",
                className: 'btn-danger float-right',
                  callback: function(){
                  //console.log('nada')
                  }

              },
              confirm: {
                label: '<i class="fa fa-check"></i>&nbsp;&nbsp;' + "Sí",
                className: 'btn-success',
                  callback: function(){
                    altacaja.$refs['datosRecibo'].imprimirRecibo(folio);
                  }
              }
            }
            });
          }
          else{
            console.log(folio)
            altacaja.$refs['datosRecibo'].imprimirRecibo(folio);
          }
        })
      },


      validarImpreso:  function(impreso){
       
        if(impreso){
          $("#PagosEncontrados_div :input").attr('disabled', 'disabled')
          setTimeout(()=>{ $("#numeroRomano").attr('disabled','disabled');}, 2000)//no deshabilita esto sin el timeout
        }
        console.log('entro::validarImpreso');
      },

      deshabilitarDevolver:  function(devuelto){
            this.$nextTick(()=>{
              
              $("#numeroRomano").attr('disabled','disabled');
              $("#filtroDeBusqueda_Area").attr('disabled','disabled');
              $("#filtroDeBusqueda_Materia").attr('disabled','disabled');
              $("#filtroDeBusqueda_TipoDocumento").attr('disabled','disabled');
              $("#filtroDeBusqueda_PartidoJudicial").attr('disabled', true);
              $("#Consecutivo").attr('disabled','disabled');
              $("#filtroDeBusqueda_Rubro").attr('disabled','disabled');
              $("#telefono").attr('disabled', 'disabled');
              $("#observaciones").attr('disabled', 'disabled');
              
            })
      },

      imprimirDevolucion: function(devolucion, datosDevolucion){
          this.$refs["datosReciboDevolucion"].imprimirReciboDevolucion(devolucion, datosDevolucion)
      },

      guardarCambiosPago: function(){
        const parametros = 
        {    
                    
          /////////////////////////campos expediente
          Expediente:{
            
            PartidoJudicialId: this.campoRequeridoEsValido(this.$refs['filtroEditar'].parametros_PartidoJudicial.partidoJudicialId) ? this.$refs['filtroEditar'].parametros_PartidoJudicial.partidoJudicialId : null,
            AreaId: this.campoRequeridoEsValido(this.$refs['filtroEditar'].parametros_Area.areaId) ? this.$refs['filtroEditar'].parametros_Area.areaId : null,
            MateriaId: this.campoRequeridoEsValido(this.$refs['filtroEditar'].parametros_Materia.materiaId) ? this.$refs['filtroEditar'].parametros_Materia.materiaId : null,
            TipoDocumentoId: this.campoRequeridoEsValido(this.$refs['filtroEditar'].parametros_TipoDocumento.tipoDocumentoId) ? this.$refs['filtroEditar'].parametros_TipoDocumento.tipoDocumentoId : null,
            Consecutivo: this.campoRequeridoEsValido(this.$refs['filtroEditar'].consecutivo) ? this.$refs['filtroEditar'].consecutivo : null,
            // CarpetaDeEjecucion: this.campoRequeridoEsValido(this.$refs['filtroEditar'].carpetadeejecucion) ? this.$refs['filtroEditar'].carpetadeejecucion :null,
            NumeroRomano: this.campoRequeridoEsValido(this.$refs['filtroEditar'].numeroRomano) ? this.$refs['filtroEditar'].numeroRomano : null,
            ////para editar
            ExpedienteId: this.campoRequeridoEsValido(this.IDEditar.ExpedienteID) ? this.IDEditar.ExpedienteID : null,
          },
          ///////////////////////campos pago
          Rubro:{
            Folio: this.campoRequeridoEsValido(this.folio) ? this.folio : null,
            TipoRubroId: this.campoRequeridoEsValido(this.$refs['filtroEditar'].parametros_Rubro.rubroId) ? this.$refs['filtroEditar'].parametros_Rubro.rubroId : null,
            Monto: this.campoRequeridoEsValido(this.$refs['filtroEditar'].monto) ? this.$refs['filtroEditar'].monto : null,
            Telefono: this.campoRequeridoEsValido(this.$refs['filtroEditar'].telefono) ? this.$refs['filtroEditar'].telefono : null,
            Observaciones: this.campoRequeridoEsValido(this.$refs['filtroEditar'].observaciones) ? this.$refs['filtroEditar'].observaciones : null,
            ////para editar
            RubroId: this.campoRequeridoEsValido(this.IDEditar.RubroId) ? this.IDEditar.RubroId : null
          },
          //////////////////////campos persona
          ...this.esAlPortador ? 
          {
            Persona:{
              Nombre: 'AL PORTADOR', 
              ApellidoPaterno: null, 
              ApellidoMaterno: null,
              PersonaId: this.campoRequeridoEsValido(this.IDEditar.PersonaId) ? this.IDEditar.PersonaId : null////para editar
            }
          } : { //false
            Persona:{
              Nombre:  this.campoRequeridoEsValido(this.$refs['filtroEditar'].nombre) ? this.$refs['filtroEditar'].nombre : null,
              ApellidoPaterno: this.campoRequeridoEsValido(this.$refs['filtroEditar'].apellido_paterno) ? this.$refs['filtroEditar'].apellido_paterno : null,
              ApellidoMaterno: this.campoRequeridoEsValido(this.$refs['filtroEditar'].apellido_materno) ? this.$refs['filtroEditar'].apellido_materno : null,
              PersonaId: this.campoRequeridoEsValido(this.IDEditar.PersonaId) ? this.IDEditar.PersonaId : null////para editar
            }
          }
        }
          //se usa la misma peticion del alta
          if(this.validarDatosBusquedaImputado(parametros) && !this.impreso){
            comun.SeEstaCargandoInformacion(true); 
            const headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false);        

            axios.post(api.conexion + api.SIVAC.sistema.administracion.pagos.AltaPagos, parametros, headerPeticion)
            .then(respuesta => {
                  comun.SeEstaCargandoInformacion(false);
                  if (respuesta.data.SiHayError) {
                      console.log(respuesta);
                      //this.limpiarTablaResultados();
                      comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                  } else {
              //Cargar Datos de Pagos
                      this.Pagos = respuesta.data.Pagos;
                      comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
              //this.imprimirRecibo(this.folio);//dejar tal vez 
                      this.buscarImputadoAPI();
                  }         
            })
            .catch(e => {
                  comun.SeEstaCargandoInformacion(false);
                  console.log("No Hay Respuesta del Servidor" + e);
                  comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
            });
          }
      },

      agregarNuevoRubro: function(){
        const parametros = 
        {                  
          /////////////////////////campos expediente
          Expediente:{
            ExpedienteId: this.campoRequeridoEsValido(this.IDAgregar.ExpedienteID) ? this.IDAgregar.ExpedienteID : null,
          },
          ///////////////////////campos pago
          Rubro:{
            Folio: this.campoRequeridoEsValido(this.folio) ? this.folio : null,
            TipoRubroId: this.campoRequeridoEsValido(this.$refs['filtroAgregar'].parametros_Rubro.rubroId) ? this.$refs['filtroAgregar'].parametros_Rubro.rubroId : null,
            Monto: this.campoRequeridoEsValido(this.$refs['filtroAgregar'].monto) ? this.$refs['filtroAgregar'].monto : null,
            Telefono: this.campoRequeridoEsValido(this.$refs['filtroAgregar'].telefono) ? this.$refs['filtroAgregar'].telefono : null,
            Observaciones: this.campoRequeridoEsValido(this.$refs['filtroAgregar'].observaciones) ? this.$refs['filtroAgregar'].observaciones : null
          },
          //////////////////////campos persona
          
          Persona:{
              PersonaId : this.campoRequeridoEsValido(this.IDAgregar.PersonaId) ? this.IDAgregar.PersonaId : null,
          }

        }
        

        if(parametros.Rubro.TipoRubroId == null || parametros.Rubro.TipoRubroId == -1
        || parametros.Rubro.Monto <=0 || parametros.Rubro.Monto == null
        || parametros.Rubro.Folio <=0 || parametros.Rubro.Folio == null
        || parametros.Rubro.Telefono== null || parametros.Rubro.Telefono == -1
        || parametros.Expediente.ExpedienteId == null || parametros.Expediente.ExpedienteId < 1
        || parametros.Persona.PersonaId == null || parametros.Persona.PersonaId < 1)
        {
          comun.mensajeDeAlerta('No se capturaron todos los datos', null, null);
        }
        else{
          comun.SeEstaCargandoInformacion(true); 
          const headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false);  

          axios.post(api.conexion + api.SIVAC.sistema.administracion.pagos.AltaPagos, parametros, headerPeticion)
          .then(respuesta => {
            comun.SeEstaCargandoInformacion(false);
            if (respuesta.data.SiHayError) {
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else {
              this.Pagos = respuesta.data.Pagos;
              comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
              this.buscarImputadoAPI();
            }         
          })
          .catch(e => {
            comun.SeEstaCargandoInformacion(false);
            console.log("No Hay Respuesta del Servidor" + e);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
          });
        }
      },

      guardarCambiosDevolucion: function(){
          const parametros = {
            Devoluciones:{
                DevolucionId : this.campoRequeridoEsValido(this.devolucionId) ? this.devolucionId : null,
                TipoBancoId: this.campoRequeridoEsValido(this.$refs['filtroEditarDevolucion'].parametros_Banco.bancoId) ? this.$refs['filtroEditarDevolucion'].parametros_Banco.bancoId : null,
                NumeroOficioJuzgado: this.campoRequeridoEsValido(this.$refs['filtroEditarDevolucion'].parametros_Oficio.numeroOficioJuzgado) ? this.$refs['filtroEditarDevolucion'].parametros_Oficio.numeroOficioJuzgado : null,
                NumeroCheque: this.campoRequeridoEsValido(this.$refs['filtroEditarDevolucion'].parametros_Oficio.cheque) ? this.$refs['filtroEditarDevolucion'].parametros_Oficio.cheque : null,
                MontoDevolucion: this.campoRequeridoEsValido(this.$refs['filtroEditarDevolucion'].monto) ? this.$refs['filtroEditarDevolucion'].monto : null,
                NumeroOficioOficialia: this.campoRequeridoEsValido(this.$refs['filtroEditarDevolucion'].parametros_Oficio.numeroOficioOficialia) ? this.$refs['filtroEditarDevolucion'].parametros_Oficio.numeroOficioOficialia : null,
                PuestoDestinatarioId: this.campoRequeridoEsValido(this.$refs['filtroEditarDevolucion'].parametros_PuestoDestinatario.puestoId) ? this.$refs['filtroEditarDevolucion'].parametros_PuestoDestinatario.puestoId : null,
                PuestoRemitenteId: this.campoRequeridoEsValido(this.$refs['filtroEditarDevolucion'].parametros_PuestoRemitente.puestoId) ? this.$refs['filtroEditarDevolucion'].parametros_PuestoRemitente.puestoId : null,
                TituloDestinatarioId: this.campoRequeridoEsValido(this.$refs['filtroEditarDevolucion'].parametros_TituloDestinatario.tituloId) ? this.$refs['filtroEditarDevolucion'].parametros_TituloDestinatario.tituloId : null,
                TituloRemitenteId: this.campoRequeridoEsValido(this.$refs['filtroEditarDevolucion'].parametros_TituloRemitente.tituloId) ? this.$refs['filtroEditarDevolucion'].parametros_TituloRemitente.tituloId : null,
                NombreDestinatario: this.campoRequeridoEsValido(this.$refs['filtroEditarDevolucion'].parametros_Oficio.nombreDestinatario) ? this.$refs['filtroEditarDevolucion'].parametros_Oficio.nombreDestinatario : null,
                NombreRemitente: this.campoRequeridoEsValido(this.$refs['filtroEditarDevolucion'].parametros_Oficio.nombreRemitente) ? this.$refs['filtroEditarDevolucion'].parametros_Oficio.nombreRemitente : null,
                Observaciones: this.campoRequeridoEsValido(this.$refs['filtroEditarDevolucion'].observacionesdevolucion) ? this.$refs['filtroEditarDevolucion'].observacionesdevolucion : null,
                FechadeDevolucion: this.campoRequeridoEsValido(this.$refs['filtroEditarDevolucion'].fechaDevolucion) ? this.$refs['filtroEditarDevolucion'].fechaDevolucion : null,
                AreaDestinatarioOficioId: this.campoRequeridoEsValido(this.$refs['filtroEditarDevolucion'].parametros_Oficio.areaDestinatarioId) ? this.$refs['filtroEditarDevolucion'].parametros_Oficio.areaDestinatarioId : null,

            },
            Persona:{
                PersonaId: this.campoRequeridoEsValido(this.IDEditar.PersonaId) ? this.IDEditar.PersonaId : null,
                Nombre: this.campoRequeridoEsValido(this.$refs['filtroEditarDevolucion'].nombre) ? this.$refs['filtroEditarDevolucion'].nombre : null,
                ApellidoPaterno: this.campoRequeridoEsValido(this.$refs['filtroEditarDevolucion'].apellido_paterno) ? this.$refs['filtroEditarDevolucion'].apellido_paterno : null,
                ApellidoMaterno: this.campoRequeridoEsValido(this.$refs['filtroEditarDevolucion'].apellido_materno) ? this.$refs['filtroEditarDevolucion'].apellido_materno : null,
            },
            rubroID : this.campoRequeridoEsValido(this.IDEditar.RubroId) ? this.IDEditar.RubroId : null
          }

          if(this.validarDatosBusquedaDevolucion(parametros)){
            comun.SeEstaCargandoInformacion(true); 
            const headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false);

            axios.post(api.conexion + api.SIVAC.sistema.caja.pagos.DevolverPagos, parametros, headerPeticion)
              .then(respuesta => {
            comun.SeEstaCargandoInformacion(false);
            if (respuesta.data.SiHayError) {
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } 
            else {
              comun.mensajeDeAlerta('Se guardaron cambios en pago a devolver', null, null);
              this.limpiarTablaResultados();
              this.buscarImputadoAPI()
              // setTimeout(()=>{
              //     console.log(this.Pagos)
              // }, 2000)
            }
            })
            .catch(e => {
              comun.SeEstaCargandoInformacion(false);
              console.log("No Hay Respuesta del Servidor" + e);
              comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null);
            });
          }
      },

      cambiarEstatusDevolucion : function(devolucion, pago){
        this.accionesDevolver.cambiarestatus = true;
        this.DevolverPago = devolucion;
        this.Pago = pago;
      },

      actualizarEstatusDevolucion : function(){
        var devolucion = this;
        var actualizarDevolucion = this.DevolverPago;

        bootbox.dialog({
          title: "Mensaje del sistema",
          message: "ADVERTENCIA. Esta a punto de actualizar como devuelto un pago de: $" + this.agregarCeros(actualizarDevolucion.MontoDevolucion) + "<br>" 
                    + " del folio " + this.Pago.Folio + ". Una vez registrado como devuelto este no podra ser modificado<br><br> Esta seguro de querer actualizar el estatus? <br>",
          buttons: {
            cancel: {
              label: '<i class="fa fa-times"></i>&nbsp;&nbsp;' + "Cancelar",
              className: 'btn-danger float-right',
                callback: function(){
                  devolucion.quitarMenuEstatus();
                }

            },
            confirm: {
              label: '<i class="fa fa-check"></i>&nbsp;&nbsp;' + "Aceptar",
              className: 'btn-success',
                callback: function(){
                  devolucion.$refs['cambioEstatus'].actualizarEstatusDevolucion(actualizarDevolucion)
                  devolucion.quitarMenuEstatus();
                }
            }
          }
          });
      },

      agregarCeros : function(monto){
          return func.agregarCeros(monto)
      },

      quitarMenuEstatus: function(){
        this.accionesDevolver.cambiarestatus = false;
      },

     }
    }
</script>




<style scoped>
  .bloquearDiv{
    pointer-events: none;
  }
  .wrapDivBloqueado
  {
    opacity: 0.7;
    cursor: not-allowed;
  }
  .fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
<style>
  
.modal-footer {
  display: inline;
}
.area_verde{
  background-color: var(--verde-pj);
    box-shadow: 0px 6px 20px 4px #161616;
    padding: 25px;
}
</style>


// WEBPACK FOOTER //
// src/components/SIVAC/Caja/Pagos.vue